import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

import globals from "./config/globals";
Vue.use(globals, store);

import Loader from "./components/loader/Loader";
import LoaderOverlay from "./components/loaderOverlay/LoaderOverlay";
Vue.component("loader", Loader);
Vue.component("loader-overlay", LoaderOverlay);

Vue.config.productionTip = false;

import { getSettings } from "@/services/settings";

async function initApp() {
  try {
    const { data } = await getSettings();
    store.dispatch("setSettings", data);

    const colors = data.colorPalette || {};
    Object.entries(colors).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--color-${key}`, value);
    });
  } catch (error) {
    console.warn("Não foi possível carregar as settings:", error);
  } finally {
    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  }
}

initApp();
